import { TDispatch, TGetState } from 'state';
import ErrorNotifier from '../../../../../services/error-notifier';
import { addToBlocklist, addToAllowlist } from '../../api/allow-and-block-list';
import { getAllUsersFromIP } from '../reducers/moderation';
import { addUserSuccess } from './../../../users/state/actions/index';
import { TModerationUser, User } from './../../../users/state/types';

type Options = {
  type: 'BLOCKLIST' | 'ALLOWLIST';
  user: User;
  userId?: string;
  ip?: string;
  applyOnHistory?: boolean;
};

const api = {
  BLOCKLIST: addToBlocklist,
  ALLOWLIST: addToAllowlist
};

const addToBlocklistOrAllowlist = ({
  user,
  ip,
  userId,
  applyOnHistory = false,
  type = 'BLOCKLIST'
}: Options) => {
  return async (dispatch: TDispatch, getState: TGetState): Promise<void> => {
    let usersFromIp = [];
    const moderationUserType: TModerationUser = getModerationUserType(type, ip);

    try {
      // TODO: Uncomment when endpoint is available
      await api[type]?.({ ip, userId, applyOnHistory });

      if (ip) {
        usersFromIp = getAllUsersFromIP(getState(), ip);
        dispatch(addUserSuccess({ type: moderationUserType, ip, user, userId }));
      }

      dispatch(addUserSuccess({ type: moderationUserType, user, userId, usersFromIp, ip }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to add to allow / block list`, { userId, ip, type });
    }
  };
};

export function getModerationUserType(type: 'BLOCKLIST' | 'ALLOWLIST', ip?: string) {
  switch (type) {
    case 'BLOCKLIST':
      return ip ? TModerationUser.BlockedIps : TModerationUser.BlockedUsers;
    case 'ALLOWLIST':
      return ip ? TModerationUser.AllowedIps : TModerationUser.AllowedUsers;
  }
}

export default addToBlocklistOrAllowlist;
